<template>
  <div
    v-if="hasTermsAndPrivacy"
    :class="`
      d-flex
      align-center
      justify-center
      flex-gap-1
      pa-4
      terms-and-privacy
      terms-and-privacy__${variant}
    `"
  >
    <a :href="termsUrl" target="_blank" rel="noopener noreferrer">
      {{ $t("_core.termsAndPrivacy.terms") }}
    </a>
    <span class="divider-element" />


    <a :href="privacyUrl" target="_blank" rel="noopener noreferrer">
      {{ $t("_core.termsAndPrivacy.privacy") }}
    </a>
  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';

export default Vue.extend({
  props: {
    variant: {
      type     : String,
      required : true,
      default  : 'login'
    }
  },
  computed: {
    termsUrl() {
      return process.env.TERMS_OF_USE_URL;
    },
    privacyUrl() {
      return process.env.PRIVACY_POLICY_URL;
    },
    hasTermsAndPrivacy() {
      return this.termsUrl && this.privacyUrl;
    }
  }
});
</script>

<style scoped lang="scss">
.terms-and-privacy {
  a {
    font-size: 0.857rem;
    letter-spacing: 0.24px;
  }

  .divider-element {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    margin: 0 3px;
  }
}

.terms-and-privacy__login {
  > a {
    color: var(--v-primary-base) !important;
  }

  > span.divider-element {
    background-color: var(--v-primary-base) !important;
  }
}

.terms-and-privacy__menu {
  background: var(--v-neutrals-10-base);
  border-top: 1px solid var(--v-neutrals-40-base);

  a {
    font-family: LatoSemiBold, sans-serif;
    font-size: 0.928571rem;
  }

  .divider-element {
    background-color: var(--v-neutrals-700-base);
  }
}
</style>
